module.exports = __webpack_public_path__ + "img/feature3@2x.f5c6eaf.png";